import { IFormValidation } from '@aston/foundation';

export class ICreateDelegationCommandValidator implements IFormValidation {
	ruleset = 'createDelegationCommandValidator';
	fields = {
		End: 'DelegationModel.End',
	};
}

export const CreateDelegationCommandValidator = new ICreateDelegationCommandValidator();
